import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MyDate} from "../../../entities/MyDate";

@Component({
  selector: 'app-ble-input-time',
  templateUrl: './ble-input-time.component.html',
  styleUrls: ['./ble-input-time.component.scss']
})
export class BleInputTimeComponent implements OnInit {

  @Input() valore?: Date;
  @Input() testo?: string;
  @Input() block?: boolean;
  @Input() invalid ? = false;
  @Input() hidden ? = false;
  @Input() minutes?: number;
  @Input() max?: number;
  @Input() min?: number;

  @Output() cambioValore = new EventEmitter();

  step = [];

  constructor() { }

  ngOnInit(): void {

  }

  inputChange(event: any) {
    this.cambioValore.emit(new MyDate(event));
  }
}
